import axios from 'axios';
import {
  NO_AUTH_DOMAIN_CHANNEL,
} from '@/Email/config/email-management';

const initialState = {
  limitsNylas: {},
  limitsSendgrid: {},
  error: null,
};

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setError(state, error) {
      state.error = error;
    },
    setLimitsNylas(state, { data, channel }) {
      state.limitsNylas = {
        ...state.limitsNylas,
        [channel]: data,
      };
    },
    setLimitsSendgrid(state, { data, channel }) {
      state.limitsSendgrid = {
        ...state.limitsSendgrid,
        [channel]: data,
      };
    },
  },
  getters: {
    hasError(state) {
      return !!state.error;
    },
    getNylasChannelLimit(state) {
      return function(channel) {
        return state.limitsNylas[channel];
      };
    },
    getSengridChannelLimit(state) {
      return function(channel) {
        return state.limitsSendgrid[channel];
      };
    },
  },
  actions: {
    async getNylasLimits({ commit }, { channel, email }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/email/limits/nylas/${channel}`,
          {
            params: {
              email,
            },
          },
        );

        commit('setLimitsNylas', { data: response.data, channel });
      } catch (error) {
        if (error.data && error.data.error) {
          commit('setError', error.data.error);
          return;
        }

        commit('setError', error);
      }
    },
    async getSendgridNoAuthLimits({ commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/email/limits/sendgrid/no-auth`,
        );

        commit('setLimitsSendgrid', { data: response.data, channel: NO_AUTH_DOMAIN_CHANNEL });
      } catch (error) {
        if (error.data && error.data.error) {
          commit('setError', error.data.error);
          return;
        }

        commit('setError', error);
      }
    },
  },
};
